import { lazy } from 'react';

export const AssignSubjectTeacherList = lazy(() => import('./assignSubjectTeacher/AssignSubjectTeacherList'));
export const AssignSubjectTeacherFilter = lazy(() => import('./assignSubjectTeacher/AssignSubjectTeacherFilter'));
export const AddAssignSubjectTeacher = lazy(() => import('./assignSubjectTeacher/AddAssignSubjectTeacher'));
export const UpdateAssignSubjectTeacher = lazy(() => import('./assignSubjectTeacher/UpdateAssignSubjectTeacher'));

export const AssignCourseSubjectList = lazy(() => import('./assignCourseSubject/AssignCourseSubjectList'));
export const AssignCourseSubjectFilter = lazy(() => import('./assignCourseSubject/AssignCourseSubjectFilter'));
export const AddAssignCourseSubject = lazy(() => import('./assignCourseSubject/AddAssignCourseSubject'));
export const UpdateAssignCourseSubject = lazy(() => import('./assignCourseSubject/UpdateAssignCourseSubject'));
